/* eslint-disable padded-blocks */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useMatch } from 'react-router-dom';
import api, {
  authHeader,
} from '../../../../../../../../../services/API/apiConfig';

const TableDataContext = createContext();

export const useTableDataContext = () => useContext(TableDataContext);

// eslint-disable-next-line react/prop-types
export const TableDataProvider = ({ children }) => {
  const [allTableDataWithExtraInfo, setAlTableDataWithExtraInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [initialData, setInitialData] = useState({});
  const [toaster, setToaster] = useState({ open: false, msg: '' });
  const [budgetTemplate, setBudgetTemplate] = useState(null);

  useEffect(() => {
    api
      .get('/budget_templates/1', {
        headers: authHeader(),
      })
      .then((res) => {
        setBudgetTemplate(res.data.data.data.items_attributes);
      });
  }, []);

  useEffect(() => {
    if (Object.keys(initialData).length === 0) {
      setInitialData(allTableDataWithExtraInfo);
    }
  }, [allTableDataWithExtraInfo]);

  const updateTableData = useCallback((newState) => {
    setAlTableDataWithExtraInfo(newState);
  }, []);

  const match = useMatch('/budget/:id'); // esse id refere-se ao id da construção. Não é o id do orçamento. Existe somente um orçamento por obra.

  // TODO: pensar em como refazer a rota para ser /contructions/:id/budgets/:id ou algo similar
  let constructionID;
  if (match) {
    const { id } = match.params;
    constructionID = id;
  }

  const matchNewBudgetPath = useMatch('/new-budget/:id');
  if (matchNewBudgetPath) {
    const { id } = matchNewBudgetPath.params;
    constructionID = id;
  }

  const tableHasDataFromFirstLayer =
    !!allTableDataWithExtraInfo?.items_attributes?.length;

  const copyItemsAttributes = useCallback((itemsArray) => {
    const copyWithValues = JSON.parse(localStorage.getItem('copyWithValues'));

    if (!itemsArray) return [];
    return itemsArray.map((item) => {
      const newItem = {
        item_num: item.item_num,
        description: item.description,
        unit: item.unit,
        quantity: copyWithValues ? String(item.quantity) : '',
        unit_price: copyWithValues ? item.unit_price : 0,
        price: copyWithValues ? item.price : 0,
        items_attributes: [],
      };

      if (item.items_attributes && item.items_attributes.length > 0) {
        newItem.items_attributes = copyItemsAttributes(item.items_attributes);
      }

      return newItem;
    });
  }, []);

  useEffect(() => {
    const constructionIdLocalStorage = JSON.parse(
      localStorage.getItem('constructionId')
    );

    if (constructionID === '0') {
      setAlTableDataWithExtraInfo({
        square_meter: 0,
        items_attributes: budgetTemplate,
        construction: allTableDataWithExtraInfo.construction,
      });
    } else if (constructionID || constructionIdLocalStorage) {
      setIsLoading(true);
      api
        .get(
          `/constructions/${constructionID || constructionIdLocalStorage}/budgets`,
          {
            headers: authHeader(),
          }
        )
        .then((response) => {
          const { data } = response.data;

          if (constructionIdLocalStorage) {
            // Ao escolher "copiar orçamento existente" na tela de novo orçamento, é setado no localStorage o id da construção, caso contrario, se for edição de orçamento, o id da construção é passado pela rota. Assim é possível saber se é uma nova criação de orçamento ou edição. PS: só mantive o que já existia, Favor, considerar refatoração desta lógica
            const stateForCreatingNewBudget = {
              square_meter: 0,
              items_attributes: copyItemsAttributes(data.items_attributes),
              construction: allTableDataWithExtraInfo.construction,
            };

            setAlTableDataWithExtraInfo(stateForCreatingNewBudget);
          } else {
            setAlTableDataWithExtraInfo(data);
          }
        })
        .finally(() => setIsLoading(false));
    }
  }, [
    allTableDataWithExtraInfo.construction,
    constructionID,
    copyItemsAttributes,
  ]);

  const value = useMemo(
    () => ({
      allTableDataWithExtraInfo,
      isLoading,
      updateTableData,
      tableHasDataFromFirstLayer,
      initialData,
      toaster,
      setToaster,
    }),
    [
      allTableDataWithExtraInfo,
      isLoading,
      updateTableData,
      tableHasDataFromFirstLayer,
      initialData,
      toaster,
      setToaster,
    ]
  );

  return (
    <TableDataContext.Provider value={value}>
      {children}
    </TableDataContext.Provider>
  );
};
